import React from 'react';
import { Clock, AlertTriangle, MapPin, CheckCircle2, Package } from 'lucide-react';
import { Widget } from '../Widget';
export type TrackingEvent = {
  timestamp: string;
  date: string;
  location: string;
  description: string;
  type: 'info' | 'warning' | 'success' | 'pickup';
};
type Props = {
  events: TrackingEvent[];
};
const ICONS = {
  info: MapPin,
  warning: AlertTriangle,
  success: CheckCircle2,
  pickup: Package
} as const;
const COLORS = {
  info: 'bg-[#0A0A0A] border-[#262626] text-[#9A9A9A]',
  warning: 'bg-[#EF4444]/10 border-[#EF4444]/30 text-[#EF4444]',
  success: 'bg-[#D4FF3A]/10 border-[#D4FF3A]/30 text-[#D4FF3A]',
  pickup: 'bg-[#0A0A0A] border-[#262626] text-[#FAFAFA]'
} as const;
export function TrackingEvents({
  events
}: Props) {
  return <Widget title="Eventi di tracking" headerRight={<span className="text-[10px] text-[#6B6B6B] font-medium flex items-center gap-1.5" data-id="element-758">
          <Clock className="h-3 w-3" data-id="element-759" />
          {events.length} eventi
        </span>} bodyPadding="md" data-id="element-757">
      <ol className="relative space-y-1" data-id="element-760">
        {events.map((event, idx) => {
        const Icon = ICONS[event.type];
        const isLast = idx === events.length - 1;
        return <li key={idx} className="relative flex gap-3 pb-4 last:pb-0" data-id="element-761">
              {!isLast && <span className="absolute left-[15px] top-8 bottom-0 w-px bg-[#262626]" data-id="element-762" />}
              <div className={`relative z-10 h-8 w-8 rounded-lg border flex items-center justify-center shrink-0 ${COLORS[event.type]}`} data-id="element-763">
                <Icon className="h-4 w-4" strokeWidth={2} data-id="element-764" />
              </div>
              <div className="flex-1 min-w-0 pt-0.5" data-id="element-765">
                <div className="flex items-baseline gap-2 flex-wrap" data-id="element-766">
                  <span className="text-sm text-[#FAFAFA] font-medium" data-id="element-767">
                    {event.description}
                  </span>
                </div>
                <div className="flex items-center gap-2 mt-0.5 text-[11px] text-[#6B6B6B]" data-id="element-768">
                  <span className="font-mono" data-id="element-769">{event.date}</span>
                  <span data-id="element-770">•</span>
                  <span className="font-mono" data-id="element-771">{event.timestamp}</span>
                  <span data-id="element-772">•</span>
                  <span className="truncate" data-id="element-773">{event.location}</span>
                </div>
              </div>
            </li>;
      })}
      </ol>
    </Widget>;
}